import React from "react";
import { Route, Redirect } from "react-router-dom";
import { withContext } from './Context';
import { TOKEN_AUTH_HEADERS } from 'constants/index';

const AppRoute = ({allow = false, context, ...props}) => {
  // Check if user has valid authentication tokens
  const hasAuthTokens = TOKEN_AUTH_HEADERS.every(header =>
    localStorage.getItem(header) !== null
  );

  // If user is not logged in or missing auth tokens, redirect to login
  if ((!context.user || !hasAuthTokens) && props.path !== "/login") {
    return <Route {...props} render={() => <Redirect to="/login" />} />;
  }

  // If user is logged in but doesn't have permission, don't render the route
  if (!allow) {
    return null;
  }

  return <Route {...props} />;
}

export default withContext(AppRoute);
